<ng-container [formGroup]="deliverableForm">
    <h3 class="form-header" mat-dialog-title i18n="@@Deliverable" t="Deliverable">Deliverable</h3>

    <div class="grid">
        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label
                        ><span
                            i18n="@@a20835f355331a7398ce79b54cff3c57e96b3c75"
                            t="a20835f355331a7398ce79b54cff3c57e96b3c75"
                            >Event</span
                        >
                        *</tsl-label
                    >
                    <tsl-select [disabled]="isDefault && isEditMode" formControlName="eventType">
                        <tsl-option [value]="0" i18n="@@Design" t="Design">Design</tsl-option>
                        <tsl-option [value]="1" i18n="@@Build" t="Build">Build</tsl-option>
                        <tsl-option [value]="2" i18n="@@Commission" t="Commission">Commission</tsl-option>
                        <tsl-option [value]="3" i18n="@@Maintenance" t="Maintenance">Maintenance</tsl-option>
                    </tsl-select>
                    <tsl-error *ngIf="eventType.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label for="deliverableType"
                        ><span i18n="@@Deliverable" t="Deliverable">Deliverable</span>*</tsl-label
                    >
                    <input
                        id="deliverableType"
                        tslInput
                        fullWidth
                        maxlength="35"
                        autocomplete="off"
                        *ngIf="!isDefault"
                        formControlName="deliverableType"
                        [tslAutocomplete]="typeAuto"
                    />
                    <input
                        id="deliverableType"
                        tslInput
                        fullWidth
                        maxlength="35"
                        *ngIf="isDefault"
                        formControlName="deliverableType"
                        [readonly]="true"
                        disabled
                    />
                    <tsl-error
                        *ngIf="deliverableType.invalid && deliverableType.errors && deliverableType.errors.required"
                        i18n="@@Required"
                        t="Required"
                        >Required</tsl-error
                    >
                    <tsl-error
                        *ngIf="
                            deliverableType.errors && !deliverableType.errors.required && deliverableType.errors.pattern
                        "
                    >
                        <span i18n="@@9081193057517588603" t="9081193057517588603"
                            >Only alphanumeric, space characters allowed, max of 35 characters</span
                        >
                    </tsl-error>
                </tsl-form-field>
            </div>
        </div>
        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label
                        ><span
                            i18n="@@3e6acd589d8b82cafd8546409da0a36469d297a0"
                            t="3e6acd589d8b82cafd8546409da0a36469d297a0"
                            >Start Date</span
                        >*</tsl-label
                    >
                    <tsl-datepicker
                        singleSelection
                        format="YYYY-MM-DD"
                        formControlName="start"
                        [disabled]="!isNotSubmitted"
                        [readonly]="true"></tsl-datepicker>
                    <tsl-error *ngIf="start.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label *ngIf="eventType.value === 3"
                        ><span
                            i18n="@@97913dee97747386f68be1431b8d0ea2144ee763"
                            t="97913dee97747386f68be1431b8d0ea2144ee763"
                            >Submitted Date</span
                        >*</tsl-label
                    >
                    <tsl-label *ngIf="eventType.value !== 3"
                        ><span
                            i18n="@@4d961692683b8c12d806cc44691277aeeade42e5"
                            t="4d961692683b8c12d806cc44691277aeeade42e5"
                            >Planned Date</span
                        >*</tsl-label
                    >
                    <tsl-datepicker
                        singleSelection
                        format="YYYY-MM-DD"
                        formControlName="planned"
                        [disabled]="!isNotSubmitted"
                        [readonly]="true"
                    ></tsl-datepicker>
                </tsl-form-field>
            </div>
        </div>
        <div class="row">
            <div fxFlex="50" *ngIf="eventType.value !== 3">
                <tsl-form-field fxFlex="95">
                    <tsl-label
                        ><span
                            i18n="@@363815f9ef9291da0b2a6f2a9322751e0d9dbaf6"
                            t="363815f9ef9291da0b2a6f2a9322751e0d9dbaf6"
                            >Actual Date</span
                        >*</tsl-label
                    >
                    <tsl-datepicker singleSelection format="YYYY-MM-DD" formControlName="actual" [readonly]="true"></tsl-datepicker>
                </tsl-form-field>
            </div>
        </div>
        <div class="row">
            <tsl-form-field *ngIf="hasApprovalComment && isNotSubmitted" fxFlex="1 1 100%">
                <tsl-label i18n="@@ReviewComment" t="ReviewComment">Review Comment</tsl-label>
                <textarea
                    tslInput
                    fullwidth
                    placeholder="Comment"
                    tPlaceholder="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" i18n-placeholder="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee"
                    formControlName="approvalComment"
                    [readonly]="true"
                    disabled
                ></textarea>
            </tsl-form-field>
            <div fxFlex="100" *ngIf="!isSIE">
                <tsl-form-field fxFlex="1 1 100%">
                    <tsl-label
                        ><span i18n="@@SubmissionComment" t="SubmissionComment">Submission Comment</span
                        >*</tsl-label
                    >
                    <textarea tslInput fullwidth placeholder="Comment" tPlaceholder="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" i18n-placeholder="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" formControlName="supplierComment"></textarea>
                </tsl-form-field>
            </div>
            <div fxFlex="100" *ngIf="isSIE">
                <tsl-form-field fxFlex="1 1 100%">
                    <div *ngIf="isNotSubmitted">
                        <tsl-label
                            ><span i18n="@@SubmissionComment" t="SubmissionComment">Submission Comment</span
                            >*</tsl-label
                        >
                        <textarea tslInput fullwidth placeholder="Comment" tPlaceholder="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" i18n-placeholder="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" formControlName="supplierComment"></textarea>
                    </div>
                    <div *ngIf="!isNotSubmitted">
                        <tsl-label i18n="@@SubmissionComment" t="SubmissionComment"
                            >Submission Comment</tsl-label
                        >
                        <textarea
                            tslInput
                            fullwidth
                            placeholder="Comment"
                            tPlaceholder="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" i18n-placeholder="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee"
                            formControlName="supplierComment"
                            [readonly]="true"
                            disabled
                        ></textarea>
                        <tsl-label
                            ><span i18n="@@ReviewComment" t="ReviewComment">Review Comment</span>*</tsl-label
                        >
                        <textarea tslInput fullwidth placeholder="Comment" tPlaceholder="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" i18n-placeholder="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" formControlName="approvalComment"></textarea>
                    </div>
                </tsl-form-field>
            </div>
        </div>
        <div class="row">
            <div class="upload-bar">
                <label for="deliFile">
                    <tsl-icon size="small">backup</tsl-icon>
                    <span class="file-input-label"
                        ><span i18n="@@Browse" t="Browse">Browse</span>*
                        <button
                            tslPopoverTrigger="hint"
                            tsl-button
                            color="blue"
                            ghost
                            tslPopover=".doc,.docx,.xls,.xlsx,.pdf,.txt,.ppt,.pptx,.jpg,.jpeg,.png,.jpg,.jpeg,.gif"
                            style="padding:0px"
                        >
                            <tsl-icon size="small">infowhite</tsl-icon>
                        </button>
                    </span>
                </label>
                <input
                    id="deliFile"
                    class="file-input"
                    type="file"
                    (change)="onUploadFile($event.target.files)"
                    accept=".doc,.docx,.xls,.xlsx,.pdf,.txt,.ppt,.pptx,.jpg,.jpeg,.png,.jpg,.jpeg,.gif"
                    multiple
                />
                <div class="image-list">
                    <ul>
                        <li *ngFor="let file of data.model.attachments">
                            <div
                                class="file-img {{ getFileType(file.name) }}"
                                matTooltip="{{ file.name }}"
                                (click)="onDownloadAttachment(file)"
                            ></div>
                            <tsl-icon size="small" status="error" (click)="onDeleteAttachment(file)">delete</tsl-icon>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="right">
        <button tsl-button outline color="black" size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button
            *ngIf="!isSIE || isNotSubmitted"
            tsl-button
            filled
            color="blue"
            size="small"
            (click)="onSaveWithoutSubmit()"
            i18n="@@Save"
            t="Save"
            >Save</button
        >
        <button
            *ngIf="!isSIE || isNotSubmitted"
            tsl-button
            filled
            color="blue"
            size="small"
            [disabled]="deliverableForm.invalid || hasNoFileAttachment"
            (click)="onSave()"
            i18n="@@Submit"
            t="Submit"
            >Submit</button
        >
        <!--Buttom 2 not for suppliers-->
        <button
            *ngIf="isSIE && !isNotSubmitted"
            tsl-button
            filled
            color="blue"
            size="small"
            [disabled]="deliverableForm.invalid || hasNoFileAttachment"
            (click)="onApproved()"
            i18n="@@Approve"
            t="Approve"
            >Approve</button
        >
        <button
            *ngIf="isSIE && !isNotSubmitted"
            tsl-button
            filled
            color="blue"
            size="small"
            [disabled]="deliverableForm.invalid || hasNoFileAttachment"
            (click)="onReject()"
            i18n="@@Reject"
            t="Reject"
            >Reject</button
        >
    </div>
</ng-container>
